import ReactDOM from "react-dom";
import { motion, useScroll } from "framer-motion";
import {
    modalHeightVariants,
    modalVariants,
} from "../../../animation/RoutesAnimations";
import ButtonComponent from "../../../components/elements/ButtonComponent";
import { useEffect, useState } from "react";
import { axiosPrivate } from "../../../api/axios";
import { CREDITOR_TAKEN_BACK } from "../../../api/apiClient";
import Map from 'react-map-gl';
import maplibregl from 'maplibre-gl';
import MapSearch from "./MapSearch";

const MapPopup = ({ onClose, selectRef, lat, lng, Llng, Llat, setLat, setLng, maptilerKey, preLocationData }: any) => {

    const [extraditionNotifiocation, setExtraditionNotification] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [mapp, setMapp] = useState<any>(maplibregl);
    const [latCache, setLatCache] = useState<any>(lat || Llat);
    const [lngCache, setLngCache] = useState<any>(lng || Llng);

    function MarkerChanger(e: any) {
        setLngCache(e.viewState.longitude)
        setLatCache(e.viewState.latitude)
    }

    function onSubmit() {
        setLat(latCache);
        setLng(lngCache);
        onClose();
    }


    return ReactDOM.createPortal(
        <>
            <div
                // variants={modalVariants}
                // initial="initial"
                // animate="final"
                id="static-modal"
                data-modal-backdrop="static"
                tabIndex={-1}
                aria-hidden="true"
                className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-screen bg-gray-500 bg-opacity-50"
            >
                <div
                    // layout
                    // variants={modalHeightVariants}
                    // initial="initial"
                    // animate="final"
                    className={`relative max-sm:w-[400px] sm:w-[660px] md:w-[660px] lg:w-[660px] overflow-hidden bg-white rounded-lg shadow pb-4 px-4 `}
                >
                    <div
                        // layout={"position"}
                        // initial="initial"
                        // animate="final"
                        className="relative"
                    >
                        <div ref={selectRef} className="flex flex-col w-full">
                            <div className=" flex items-end justify-end rounded-t pt-2">
                                <button
                                    type="button"
                                    onClick={() => {
                                        onClose();
                                    }}
                                    className="text-gray-400 bg-transparent rounded-lg w-8 h-8 inline-flex justify-start items-center"
                                >
                                    <img src="/icons/x.svg" alt="icon" width={20} />
                                    <span className="sr-only">Close modal</span>
                                </button>
                            </div>
                            {/* code here */}
                            <div className="flex items-center justify-center w-full flex-col gap-6 px-4">
                                <p className="text-gray-900 text-Title/20/Bold text-right w-full">انتخاب موقعیت مکانی فروشگاه</p>
                                {latCache && lngCache && (<>
                                    <div className='flex w-full max-sm:h-[200px] sm:h-[490px] md:h-[490px] lg:h-[490px] relative justify-center items-center rounded-lg overflow-hidden'>
                                    
                                    <Map mapLib={mapp} onZoom={MarkerChanger} onMove={MarkerChanger}
                                        initialViewState={{
                                            latitude: latCache,
                                            longitude: lngCache,
                                            zoom: 15
                                        }}
                                        latitude={latCache}
                                        longitude={lngCache}

                                        mapStyle={`https://api.maptiler.com/maps/streets/style.json?key=${maptilerKey}`}
                                    >
                                    </Map>
                                

                                <img className=' absolute flex z-10 right-auto max-sm:top-[82px] sm:top-[225px] md:top-[225px] lg:top-[225px]' src="/icons/marker-blue.svg" alt='not found' />
                                <MapSearch MapAPIkey={maptilerKey} setLngCache={setLngCache} setLatCache={setLatCache} />
                            </div>
                                </>)}

                                <div className="flex items-center justify-center w-full gap-4">
                                    <ButtonComponent
                                        type="button"
                                        variant="outlined"
                                        onClick={() => { onClose() }}
                                    >لغو</ButtonComponent>
                                    <ButtonComponent
                                        type="button"
                                        disabled={lat === latCache}
                                        onClick={() => onSubmit()}
                                    >تایید</ButtonComponent>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById("modal-root")!
    );
};

export default MapPopup;
